import {} from './types.js'

export default {
  tagsNames: state => {
    return state.tag_list.map(tag => tag.name)
  }
}
